// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic

// styles
import './styles/graphic.scss';

/* develblock:start */

import * as d3 from 'd3';
import { format } from 'd3-format';
import meta from './data/meta.json';
import { stylePremium } from './utils/helpers';
import { bandAxis, linearAxis } from '../../../factory/axes';

import './styles/graphic.scss';

// const d3 = {
//   json,
//   max,
//   min,
//   select,
//   timeFormat,
//   timeParse,
//   timeFormatDefaultLocale,
// };

// formatD3Time();
d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  shortMonths: [
    'Ene.',
    'Feb.',
    'Mazo',
    'Abril',
    'Mayo',
    'Jun.',
    'Jul.',
    'Ago.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dic.',
  ],
});

function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function formatNum(num) {
  const str = num.toFixed(1).split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
  }
  return str.join(',');
}

const fmtComma = format(',');
const fmtSI = format('.1s');
const fmtThou = format('~s');
const getHeadline = (cur, prev) => {
  if (cur.amt === 0) return null;
  // sample headline from previous graphic
  // US economy added 223,000 jobs in December, unemployment rate dropped to 3.5%
  const rateDir = cur.rate - prev.rate;
  return [
    'La economía estadounidense',
    cur.amt > 0 ? 'agregó' : 'perdió',
    formatNumber(Math.abs(cur.amt)),
    `puesto${cur.amt !== 1 ? 's' : ''}`,
    // `de trabajo en ${cur.month}.`,
    'de trabajo el mes anterior.',
    'La tasa de desempleo',
    `${(rateDir < 0) ? 'bajó a' : (rateDir > 0) ? 'subió a' : 'se mantuvo en'}`,
    `${formatNum(cur.rate)}%.`,
  ].join(' ');
};


const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


let minValue;
let maxValue;


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let data;
d3.json('https://ix.cnn.io/data/jobs/monthly_employment_situation_last_year_merged.json').then((jsondata) => {
  // Create our chart data from the raw json data
  let curYear = '';
  data = jsondata.data.map(
    (d, i) => {
      const yr = d.date.split('-')[0];
      const hasYear = yr !== curYear;
      curYear = yr;
      return {
        label: d.month,
        year: yr,
        hasYear,
        amt: d.jobs * 1000,
        date: d3.timeParse('%Y-%m')(d.month_year),
        rate: d.rate,
        month: d.month,
        notable: d.notable,
        pub_date: d.date,
      };
    },
  )
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  minValue = Math.min(0, d3.min(data, d => d.amt));
  maxValue = d3.max(data, d => d.amt) * 1.2;

  // Dynamically build headline based on most recent data
  const mostRecent = data[data.length - 1];
  const headline = getHeadline(mostRecent, data[data.length - 2]);
  const publishMonth = d3.timeFormat('%-d de %B de %Y.')(d3.timeParse('%Y-%m-%d')(mostRecent.pub_date));


  if (headline) {
    d3.select('h1.headline')
      .text(headline);
  }

  if (mostRecent.notable && mostRecent.notable !== '') {
    d3.select('h2.dek')
      .text(mostRecent.notable);
  }

  const timeStampFootnoote = d3.select('p#timestamp')
    .html(`Datos actualizados por última vez el ${publishMonth}`);


  draw();

  window.onresize = draw;
});


function draw() {
  const container = d3.select('#graphic');
  container.html('');


  const initialWidth = container.node().clientWidth;
  const initialHeight = 400;
  const isMobile = initialWidth <= 500;

  const margins = {
    top: 30,
    right: 20,
    bottom: 25,
    left: (isMobile) ? 50 : 75,
  };

  const width = initialWidth - margins.right - margins.left;


  const height = 400;
  const padding = 0.15;


  const chartHeight = height - margins.top - margins.bottom;
  const chartWidth = initialWidth - margins.left - margins.right;

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, chartWidth],
    domain: data.map(d => d.date),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [chartHeight, 0],
    domain: [Math.min(0, minValue), maxValue],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  const yTicks = isMobile ? 5 : 5;


  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', height);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const formatMonth = d3.timeFormat('%b');

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, chartHeight]})`)
    .call(
      xAxis(x)
        .tickFormat(d => `${formatMonth(d)}`),
    );


  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtThou(d).toUpperCase()
          : formatNumber(d)
        )
        : (Math.abs(d) > 9999 * 100000
          ? fmtThou(d).toUpperCase()
          : formatNumber(d)
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0 && minValue >= 0)
    .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  const bars = group.append('g')
    .attr('class', 'bars');

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.date), y(d.amt < 0 ? 0 : d.amt)]})`);

  bar.append('title')
    .text(d => `${d.label} (${fmtComma(d.amt)})`);

  bar.append('rect')
    .attr('class', d => (+d.amt < 0 ? 'loss' : ''))
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  bar.append('text')
    .attr('class', 'value in')
    .attr('role', 'listitem')
    .attr('x', x.bandwidth() / 2)
    .attr('dy', d => ((d.amt > y.domain()[1] * 0.9)
      ? '1.1em'
      : '-.5em'))
    .attr('text-anchor', 'middle')
    .text(d => (isMobile
      ? (Math.abs(d.amt) > 999
        ? fmtThou(d.amt).toUpperCase()
        : fmtComma(d.amt)
      )
      : (Math.abs(d.amt) > 9999
        ? fmtThou(d.amt).toUpperCase()
        : fmtComma(d.amt)
      )));

  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }


  window.pymChild.sendHeight();

  d3.select('#root')
    .attr('class', 'ready');
}
